import { BankDetailsDebitsHistoryPanel } from "@/components/organisms";

export const BankDetailsDebitsHistory = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <BankDetailsDebitsHistoryPanel />
    </div>
  );
};
